// src/utils/raceUtils.js
//
// Resolve the "race to N games" target for a single match from the tournament's
// settings. The winners bracket, single-elim, modified-single-elim, round-robin,
// and grand-final matches all use the primary (winners) race length; only the
// losers bracket uses its own. Falls back through the legacy single `raceLength`
// field and finally a sane default so scoring never becomes uncapped.
export const getMatchRaceTarget = (match, settings = {}) => {
  // A default parameter only applies when the arg is `undefined`, not `null`.
  // Callers (e.g. read-only TableView) may pass `null` explicitly, so coalesce
  // to an empty object here — otherwise `null.winnersRaceLength` throws and, in
  // a render path, takes the whole view down (blank screen).
  const s = settings || {};
  const winners = Number(s.winnersRaceLength) || Number(s.raceLength) || 5;
  const losers = Number(s.losersRaceLength) || Number(s.raceLength) || winners;
  return match?.bracket === 'L' ? losers : winners;
};
